module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/companies/createcompany.component.scss
// module id = 346
// module chunks = 1